export const routes = {
    app: '/',
    payin: '/payin',
    'payin-order': '/payin/orders/:orderId',
    payout: '/payout',
    'payout-order': '/payout/orders/:orderId',
    settings: '/settings',
    'privacy-policy': '/privacy-policy',
    auth: '/auth',
    recover: '/recover',
    tickets: '/tickets',
    traders: '/traders',
    'payout-trader': '/traders/payout/:traderId',
    cascades: '/cascades',
    'payout-cascade': '/cascades/cascade/:cascadeId',
    'payout-cascade-group': '/cascades/group/:groupId',
    'payout-cascade-template': '/cascades/template/:templateId',
} as const;
